import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
// import "firebase/analytics" // NOPE until resolved -> https://github.com/firebase/firebase-js-sdk/issues/2393
// import "firebase/performance" // NOPE until resolved -> https://github.com/firebase/firebase-js-sdk/issues/2393
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

// Sentry
if (process.env.VUE_APP_ENVIRONMENT != 'local_dev') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    release: `platformaone-cart@${process.env.VUE_APP_VERSION}`, // TODO start using semver
    environment: process.env.VUE_APP_ENVIRONMENT,
    debug: false,
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
        logErrors: true // passthrough to Vue logError handler
      }),
      new Integrations.CaptureConsole({
        // levels: ['log', 'info', 'warn', 'error', 'debug', 'assert']
        levels: ['error', 'warn']
      })
    ]
  })
}

// Firebase
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
}
firebase.initializeApp(firebaseConfig)

// redirect local_dev to emulator
if (process.env.VUE_APP_ENVIRONMENT == 'local_dev') {
  firebase.functions().useFunctionsEmulator('http://localhost:5001')
  var fbsFn = firebase.functions()
  
  // var fbsDb = firebase.firestore()
  // fbsDb.settings({
  //   host: 'localhost:8432',
  //   ssl: false
  // })
  var fbsDb = firebase.firestore()
  
} else {
  var fbsFn = firebase.app().functions('europe-west1')
  var fbsDb = firebase.firestore()
}

// exports
export const fb = firebase
export const db = fbsDb
export const fn = fbsFn
export const auth = firebase.auth()
// export const analytics = firebase.analytics() // NOPE until resolved -> https://github.com/firebase/firebase-js-sdk/issues/2393
// export const performance = firebase.performance() // NOPE until resolved -> https://github.com/firebase/firebase-js-sdk/issues/2393
export const sentry = Sentry ? Sentry : null